export default __webpack_public_path__ + "static/media/DSC08830.511e3a15.jpg";